import {NextPage} from 'next';
import {wineShopXProductsController, winshopXController} from 'modules/wineshops-list/controllers';
import {WineShopWrapper} from 'modules/wineshops-list/pages/WineShopWrapper';
import {withBasicDataServerSide} from 'core/next/controllers';
import {IBreadcrumb} from 'modules/seo/types';

export interface IProps {
    isPage?: boolean;
    breadcrumbs?: IBreadcrumb[];
}

const WineShopPage: NextPage<{pageProps: IProps}> = ({pageProps: {breadcrumbs = []}}) => {
    // TODO: вернуть, когда бэки доработают фильтрацию и поиск, подумать чтобы заменить пагинацию на "Показать больше"
    // TODO 2: переименовать [code] папку в [...code]
    //  и написать алгоритм парсинга строки
    //  на пагинацию, фильтрацию и еще какие-то параметры
    //  и проверить на валидные данные и если данные не валидны выдать 404
    // if (isPage) {
    //     return <WineShopSearchPage />;
    // }

    return <WineShopWrapper breadcrumbs={breadcrumbs} />;
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    // TODO: вернуть, когда бэки доработают фильтрацию и поиск, подумать чтобы заменить пагинацию на "Показать больше"
    // const page = findMatch(ctx?.asPath);
    //
    // if (page) {
    //     await wineshopListController(store, ctx);
    //     return {
    //         props: {isPage: true},
    //     };
    // }

    const wineshop = await winshopXController(store, ctx);

    await wineShopXProductsController(store, ctx);

    return {
        props: {
            isPage: false,
            breadcrumbs: wineshop?.breadcrumbs ?? [],
        },
    };
});

export default WineShopPage;
